import { app } from '../../../../app';
import { Controller } from './purchase-license.controller';

app.component('purchaseLicense', {
    bindings:{
        licenseDetails: '<',
        licenseTiers: '<',
    },
    controller: Controller,
    templateUrl: require('./purchase-license.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/purchase-license/purchase-license.component.js